import * as tslib_1 from "tslib";
import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import debounce from 'lodash.debounce';
import { classNames, css } from './utils';
import ToggleButton from './ToggleButton';
export var Style = function (_a) {
    var css = _a.css;
    return (React.createElement("style", { dangerouslySetInnerHTML: {
            __html: css,
        } }));
};
var styles = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  .PriorityNav_Root {\n    position: relative;\n    white-space: nowrap;\n  }\n  .PriorityNav_Main {\n    display: inline-block;\n  }\n  .PriorityNav_Item {\n    display: inline-block;\n  }\n  .PriorityNav_Button {\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n    &:hover {\n      color: #999;\n    }\n  }\n"], ["\n  .PriorityNav_Root {\n    position: relative;\n    white-space: nowrap;\n  }\n  .PriorityNav_Main {\n    display: inline-block;\n  }\n  .PriorityNav_Item {\n    display: inline-block;\n  }\n  .PriorityNav_Button {\n    display: inline-block;\n    vertical-align: middle;\n    cursor: pointer;\n    &:hover {\n      color: #999;\n    }\n  }\n"])));
var Div = React.forwardRef(function (props, ref) { return (React.createElement("div", tslib_1.__assign({ ref: ref }, props, { className: props.className }))); });
var PriorityNav = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityNav, _super);
    function PriorityNav() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            children: _this.props.children,
            dropdownItems: [],
            lastItemWidth: [],
            isOpen: false,
        };
        _this.outerNav = React.createRef();
        _this.nav = React.createRef();
        _this.items = new Map();
        // tslint:disable-next-line:member-ordering
        _this.doesItFit = debounce(function () {
            if (_this.nav.current && _this.outerNav.current) {
                var outerWidth_1 = _this.outerNav.current.offsetWidth;
                var totalWidth = _this.nav.current.offsetWidth;
                if (_this.items.size > 0 && totalWidth > outerWidth_1) {
                    _this.moveItemToList();
                    _this.doesItFit();
                }
                else if (_this.state.dropdownItems.length > 0 &&
                    outerWidth_1 >
                        totalWidth +
                            _this.state.lastItemWidth[_this.state.lastItemWidth.length - 1] +
                            _this.props.offset) {
                    _this.moveItemToNav();
                    _this.doesItFit();
                }
            }
        }, _this.props.debounce);
        _this.toggleShow = function () {
            _this.setState(function (prevState) { return ({
                isOpen: !prevState.isOpen,
            }); });
        };
        _this.getButtonProps = function () {
            return {
                onClick: _this.toggleShow,
            };
        };
        // -------------------------------------
        //   Move Item
        // -------------------------------------
        _this.moveItemToList = function () {
            _this.setState(function (prevState) {
                var children = prevState.children.slice();
                var lastItem = children.splice(-1, 1);
                return {
                    children: children,
                    dropdownItems: lastItem.concat(prevState.dropdownItems),
                    lastItemWidth: prevState.lastItemWidth.concat([
                        _this.items.get(prevState.children.length - 1).clientWidth,
                    ]),
                };
            });
        };
        _this.moveItemToNav = function () {
            _this.setState(function (prevState, props) {
                var dropdownItems = prevState.dropdownItems.slice();
                var firstItemFromList = dropdownItems.splice(0, 1);
                return {
                    children: prevState.children.slice().concat(firstItemFromList),
                    dropdownItems: dropdownItems,
                    lastItemWidth: prevState.lastItemWidth.splice(0, 1),
                };
            });
        };
        // -------------------------------------
        //   Render Method
        // -------------------------------------
        _this.renderIcon = function () {
            if (_this.props.icon) {
                if (typeof _this.props.icon === 'function') {
                    return _this.props.icon();
                }
                return _this.props.icon;
            }
            return React.createElement(ToggleButton, tslib_1.__assign({}, _this.getButtonProps()));
        };
        _this.renderDropdownList = function () {
            var dropdownChildren = _this.state.dropdownItems.map(function (item) { return item; });
            return _this.props.dropdownList(dropdownChildren, _this.state.isOpen);
        };
        _this.renderChildren = function () {
            var _a = _this.props, children = _a.children, itemPadding = _a.itemPadding, props = tslib_1.__rest(_a, ["children", "itemPadding"]);
            return React.Children.map(_this.state.children, function (child, i) {
                return (React.createElement(Div, { ref: function (s) { return _this.setItems(i, s); }, style: {
                        padding: itemPadding,
                    }, className: 'PriorityNav_Item', key: i }, child));
            });
        };
        _this.setItems = function (i, s) {
            if (s) {
                _this.items.set(i, s);
            }
        };
        return _this;
    }
    PriorityNav.prototype.componentDidMount = function () {
        this.resizeObserver = new ResizeObserver(this.doesItFit);
        if (this.outerNav.current) {
            this.resizeObserver.observe(this.outerNav.current);
        }
        this.doesItFit();
    };
    PriorityNav.prototype.componentWillUnmount = function () {
        if (this.outerNav.current) {
            this.resizeObserver.unobserve(this.outerNav.current);
        }
    };
    PriorityNav.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Div, { style: {
                    minWidth: this.props.minWidth,
                }, ref: this.outerNav, className: classNames('PriorityNav_Root', this.props.className) },
                React.createElement(Style, { css: styles }),
                React.createElement(Div, { ref: this.nav, className: classNames('PriorityNav_Main') },
                    this.renderChildren(),
                    this.renderIcon())),
            this.renderDropdownList()));
    };
    PriorityNav.defaultProps = {
        itemPadding: 0,
        offset: 0,
        debounce: 0,
        placement: 'bottomRight',
        minWidth: '250px',
        navSetting: {
            background: 'unset',
        },
        isOpen: false,
        icon: undefined,
    };
    return PriorityNav;
}(React.Component));
export default PriorityNav;
var templateObject_1;
//# sourceMappingURL=PriorityNav.js.map